import * as Types from '../../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
export type InviteLinkModalMemberFragment = { __typename?: 'BusinessUser', email?: string | null, inviteSecret: string };

export const InviteLinkModalMemberFragmentDoc = gql`
    fragment InviteLinkModalMember on BusinessUser {
  email
  inviteSecret
}
    `;